import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FunctionsHelper } from 'src/app/helpers/functions';
import { AuthService } from 'src/app/shared/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  submitClicked: boolean = false;
  formSubmitted: boolean = false;
  error: string = '';

  emailSent: boolean = false;
  emailResent: boolean = false;

  forgotPasswordForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(this._functionsHelper.regexPatterns.email)]),
  });

  get forgotPasswordFormControl() {
    return this.forgotPasswordForm.controls;
  }

  onSubmit() {
    this.submitClicked = true;
    this.error = '';

    if (this.forgotPasswordForm.valid) {
      this.formSubmitted = true;

      this.authService
        .forgotPassword(this.forgotPasswordForm.value.email)
        .then((user) => {
          if (user.result) {
            this.emailSent = true;
          }
        })
        .catch((error) => {
          this.error = error.message;
          this.formSubmitted = false;
        });
    }
  }

  resendEmail() {
    this.emailResent = true;
    this.authService
      .forgotPassword(this.forgotPasswordForm.value.email)
      .then((user) => {
        if (user.result) {
          this.toastr.success('Email Resent successfully!');
        }
      })
      .catch((error) => {
        this.error = error.message;
        this.formSubmitted = false;
      });
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private _functionsHelper: FunctionsHelper,
    private toastr: ToastrService
  ) { }
}
